<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Identification Details</h4>
</div>
<div class="modal-body">
    <p-table #dt2 [value]="commercialVehiclePermitNumberViewModel" [lazy]="true" (onLazyLoad)="populateCMLPermits($event)" [paginator]="true"
             [rows]="10" [totalRecords]="totalRecords" styleClass="mvd_table--notfixed">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Type</th>
                <th>Permit Number</th>
                <th>Issue Date</th>
                <th>Expiration Date</th>
                <th>Status</th>
                <th>Issued By</th>
                <th>Issued To</th>
                <th>USDOT #</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td>{{data.commercialVehiclePermitTypeDisplayValue}}</td>
                <td>{{data.id}}</td>
                <td>{{data.issueDate | shortDate}}</td>
                <td>{{data.expirationDate | shortDate}}</td>
                <td>{{data.commercialVehiclePermitStatusTypeDisplayValue}}</td>
                <td>{{data.createdBy}}</td>
                <td>{{data.customerDisplayName}}</td>
                <td>{{data.customerUSDOTNumber}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
    </div>
</div>